/* eslint-disable */
import React, { useEffect, useState } from 'react';
import RecursiveAccordion from '../Components/RecursiveAccordian/recursiveAccordion';
import {
  getEffortData,
  editEffortData,
  addEffortData,
  deleteEffortData,
} from '../../../../Api/request/effortWorkflow';
import UseAxios from '../../../../Api/http/http';
import HeaderSection from '../Components/Header/header';
import CommercialDialog from '../Components/Dialogs/AddDialog/addDialog';
import EditDialog from '../Components/Dialogs/EditDialog/editDialog';
import { dealRoleList } from '../../../../Api/request/roleMaster';
import PropTypes from 'prop-types';

const parameters = ['Deal Effort', 'Vertical'];

const App = ({ alignment, hasAccess  }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [data, setData] = useState([]);
  const [selectedNode, setSelectedNode] = useState({});
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [approverOptions, setApproverOptions] = useState([]);

  const handleEdit = (node) => {
    setSelectedNode(node);
    setIsEditDialogOpen(true);
  };

  const updateDetails = (id, newDetails, parentNode) => {
    const replaceDetails = (node) => {
      if (node.details) {
        node.details = newDetails;
      }
      for (const key in node) {
        if (typeof node[key] === 'object' && node[key] !== null) {
          replaceDetails(node[key]);
        }
      }
    };

    replaceDetails(parentNode);

    const fetchData = async () => {
      try {
        const res = await UseAxios(editEffortData(parentNode));
        if (res.data.status === 200) {
          parentNode = res.data.response;
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  };

  const handlePopoverOpen = (event, parentId = null) => {
    if (event) {
      setAnchorEl(event.currentTarget);
      setIsDialogOpen(true);
    }
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
    setAnchorEl(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('authToken');
      try {
        const res = await UseAxios(getEffortData(token));
        if (res.data.status === 200) {
          setData(res.data.response);
        } else {
          setData([]);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    const fetchApprovers = async () => {
      const token = localStorage.getItem('authToken');
      try {
        const res = await UseAxios(dealRoleList(token));
        const data = res.data.roleDetails;
        setApproverOptions(data);
      } catch (err) {
        console.error('Error fetching approver options:', err);
      }
    };

    fetchApprovers();

    fetchData();
  }, []);

  const addData = (newDetails) => {
    const fetchData = async () => {
      try {
        const res = await UseAxios(addEffortData(newDetails));
        if (res.data.status === 200) {
          const getData = await UseAxios(getEffortData());
          setData(getData.data.response);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  };

  const handleDelete = (node) => {
    const deleteData = async () => {
      try {
        const res = await UseAxios(deleteEffortData(node));
        if (res.data.status === 200) {
          const getData = await UseAxios(getEffortData());
          setData(getData.data.response);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    deleteData();
  };

  const editData = (newDetails) => {
    const fetchData = async () => {
      try {
        const res = await UseAxios(editEffortData(newDetails));
        if (res.data.status === 200) {
          const getData = await UseAxios(getEffortData());
          setData(getData.data.response);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  };

  return (
    <div style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
      <HeaderSection handlePopoverOpen={handlePopoverOpen} hasAccess={hasAccess} />
      {data.length > 0 ? (
        <>
          {data.map((node) => (
            <RecursiveAccordion
              key={node.id}
              node={node}
              approverOptions={approverOptions}
              updateDetails={(id, newDetails) =>
                updateDetails(id, newDetails, node)
              }
              handleEdit={() => handleEdit(node)}
              handleDelete={() => handleDelete(node)}
              hasAccess={hasAccess}
            />
          ))}
        </>
      ) : (
        <p>No data found</p>
      )}

      {isDialogOpen && (
        <CommercialDialog
          isOpen={isDialogOpen}
          onClose={handleDialogClose}
          anchorEl={anchorEl}
          addData={addData}
          parameters={parameters}
          alignment={alignment}
        />
      )}
      <EditDialog
        isEditDialogOpen={isEditDialogOpen}
        setIsEditDialogOpen={setIsEditDialogOpen}
        selectedNode={selectedNode}
        setSelectedNode={setSelectedNode}
        editFromDialog={editData}
        alignment={alignment}
      />
    </div>
  );
};

App.propTypes = {
  alignment: PropTypes.string.isRequired,
  hasAccess: PropTypes.func.isRequired,
  
};

export default App;
